module.exports = __webpack_public_path__ + "img/LifeChain_Logo.24f7e0ea.jpg";